import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { tipDisplay, formatTipAmount } from '../../../services/FundedTips';

export function TipSummary({ order, showAmounts = true, showWarning = true }) {
  const display = tipDisplay(order);
  const showLowWarning = showWarning && display.low;
  if (!display.applicable || (!showAmounts && !showLowWarning)) return null;
  return (
    <Box my={1} aria-label="Order gratuity">
      {showLowWarning && (
        <Alert severity="warning" style={{ padding: '0 8px', marginBottom: 4 }}>
          {display.customer === 0
            ? '$0 customer gratuity — below $1.00'
            : 'Low customer gratuity — below $1.00'}
        </Alert>
      )}
      {showAmounts && (
        <>
          <Typography variant="caption" component="div">
            Customer gratuity: {formatTipAmount(display.customer)}
          </Typography>
          <Typography variant="caption" component="div">
            Eatzy-funded: {formatTipAmount(display.funded)}
          </Typography>
          {display.reason && display.customer === null && (
            <Typography variant="caption" color="textSecondary">{display.reason}</Typography>
          )}
        </>
      )}
    </Box>
  );
}
